/*jshint esversion: 6 */
/* jshint node: true */

/**
 * @file
 * Global utilities.
 *
 */
;(function ($, Drupal) {

    "use strict";

    Drupal.behaviors.ithh = {
        attach: function (context, settings) {

          $('.form-type-datelist').find('.form-type-select select').each(function () {
            $(this).select2();
          });

          $('.form-type-select').find('select.select2').once('select2-init').each(function () {
            $(this).select2();
          });

        }
    };

})(jQuery, Drupal);
